import * as React from 'react';
import set from 'lodash/set';
import get from 'lodash/get';
import { columnName, tableName } from '../../case-data-model';

export function readonlyWhenSigned<P extends object>() {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<P>) => {

    return class extends React.PureComponent<P> {
      public render() {
        const {
          readOnly,
          rowEntity,
          value
        } = this.props as any;

        let readOnlyOverride = undefined;
        const modifiedProps: P = {...this.props as any};
        const signatureDate = get(rowEntity, `${columnName[tableName.signature].signatureDate}[0].value`);        

        if(value && signatureDate){
          readOnlyOverride = true;
        }

        // domain criteria, typically effect of being a case administrator
        if(readOnly === false) {
          readOnlyOverride = false;
        }

        // case admin for others rows: do nothing (let server provide readonly for unsign)
        if (readOnlyOverride !== undefined) {
          set(modifiedProps as P, 'readOnly', readOnlyOverride);
        }

        return <WrappedComponent { ...modifiedProps } /> ;
      }
    };
  };
}
